export default __webpack_public_path__ + "static/media/map-marker.385272fd.gif";